import React from 'react'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslationRankmi } from 'helpers/translations.helper'
import aiEvaluationLoadingGif from 'assets/ai-evaluation-loading.gif'
import AiGradientDefs from './AiGradientDefs'
import {
  LoaderBox,
  LoaderImage,
  LoaderSection,
  StepCircle,
  StepConnector,
  StepLabel,
  StepRow,
  StepsColumn,
  StepperRoot,
  StepStatus,
} from './GenerationStepper.styled'

interface Props {
  blockCount: number
  activeStep: number
}

const getStepStatus = (index: number, activeStep: number): StepStatus => {
  if (index < activeStep) return 'finish'
  if (index === activeStep) return 'process'
  return 'wait'
}

export const GenerationStepper: React.FC<Props> = ({
  blockCount,
  activeStep,
}) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.generationModal',
  })

  const steps = [
    t('stepReading', { count: blockCount || 1 }),
    t('stepAnalyzing'),
    t('stepWriting'),
  ]

  return (
    <>
      <AiGradientDefs />
      <StepperRoot>
        <StepsColumn>
          {steps.map((label, index) => {
            const status = getStepStatus(index, activeStep)

            return (
              <React.Fragment key={label}>
                <StepRow>
                  <StepCircle $status={status} aria-hidden>
                    {status === 'finish' ? (
                      <FontAwesomeIcon icon={faCheck} />
                    ) : (
                      index + 1
                    )}
                  </StepCircle>
                  <StepLabel $active={status === 'process'}>{label}</StepLabel>
                </StepRow>
                {index < steps.length - 1 && <StepConnector />}
              </React.Fragment>
            )
          })}
        </StepsColumn>
        <LoaderSection aria-hidden>
          <LoaderBox>
            <LoaderImage src={aiEvaluationLoadingGif} alt="" />
          </LoaderBox>
        </LoaderSection>
      </StepperRoot>
    </>
  )
}

export default GenerationStepper
